import { useOrientation } from '@/hooks/useOrientation';
import styles from './styles.module.scss';
import clsx from 'clsx';
import ShopSearchControl from '@/components/feature/shop/shop-search/shop-search-control';
import { useCallback } from 'react';
import { SHOP_SEARCH_MODE } from '@/enums/shop';
import ShopSearchByText from '@/components/feature/shop/shop-search/shop-search-by-text';
import ShopSearchByFloor from '@/components/feature/shop/shop-search/shop-search-by-floor';
import ShopSearchByCategory from '@/components/feature/shop/shop-search/shop-search-by-category';
import { useShopStore } from '@/stores';

interface ShopSearchProps {
    isVerticalFullscreen?: boolean;
}

const ShopSearch = ({ isVerticalFullscreen = false }: ShopSearchProps) => {
    const { isHorizontal } = useOrientation();
    const currentMode = useShopStore((state) => state.currentMode);

    const renderContent = useCallback(() => {
        switch (currentMode) {
            case SHOP_SEARCH_MODE.SEARCH_BY_TEXT:
                return <ShopSearchByText isVerticalFullscreen={isVerticalFullscreen} />;
            case SHOP_SEARCH_MODE.SEARCH_BY_FLOOR:
                return <ShopSearchByFloor />;
            case SHOP_SEARCH_MODE.SEARCH_BY_CATEGORY:
                return <ShopSearchByCategory />;
            default:
                return <ShopSearchByText isVerticalFullscreen={isVerticalFullscreen} />;
        }
    }, [currentMode, isVerticalFullscreen]);

    return (
        <div
            className={clsx(styles['shop-search'], {
                [styles['shop-search__horizontal']]: isHorizontal,
                [styles['shop-search__vertical']]: !isHorizontal,
                [styles['shop-search__vertical-fullscreen']]: isVerticalFullscreen,
            })}
        >
            <div
                className={clsx(styles['shop-search__control'], {
                    [styles['shop-search__control__horizontal']]: isHorizontal,
                    [styles['shop-search__control__vertical']]: !isHorizontal && !isVerticalFullscreen,
                    [styles['shop-search__control__vertical-fullscreen']]: isVerticalFullscreen,
                })}
            >
                <ShopSearchControl isVerticalFullscreen={isVerticalFullscreen} currentMode={currentMode} />
            </div>
            <div className={clsx(styles['shop-search__content'], {
                    [styles['shop-search__content__vertical']]: !isHorizontal,
            })}>{renderContent()}</div>
        </div>
    );
};

export default ShopSearch;
